import { connect, injectReducer, injectSaga } from '@vfde-sails/core';
import addressValidationContainer from '../AddressValidation';
import availabilityResultContainer from '../AvailabilityResult';
import * as mapDispatch from './action';
import appReducer from './reducer';
import leadManagementContainer from '../LeadManagement';
import { mapStateToProps } from './selector';
import { NameSpace, AppId, AddressFormId, Views } from '../../enum';
import { mountOverlay, updateOverlay } from '../../components/overlay';
import appSaga from './saga';
import { mountLoadingSpinner, updateLoadingSpinner } from '../../components/loadingSpinner';
import { getUpdateFlags } from './update';
import { mountAccordion } from '../../components/accordion';
import { mountButtonLink } from '../../components/buttonLink';
import { updateActiveView } from '../../components/activeView';
import { mountRelatedLinks } from '../../components/relatedLinks';
import { mountIconTextBanner } from '../../components/iconTextBanner';
import { mountCarousel } from '../../components/carousel';
import { initFootnotes } from '../../components/footnote';
import { toggleElementVisibilityById } from '@vfde-brix/ws10/core';
import { mountImageHeader, updateImageHeader } from '../../components/imageHeader';

const actionMap = {
    ...mapDispatch,
};

export type State = ReturnType<typeof mapStateToProps>;
export type Actions = typeof actionMap;

function appContainer(_state: State, actions: Actions) {
    injectSaga(NameSpace.APP, appSaga);
    injectReducer(NameSpace.APP, appReducer);

    addressValidationContainer();
    availabilityResultContainer();

    const showLinksView = () => actions.setActiveView(Views.LINKS);
    const showFormView = () => actions.setActiveView(Views.FORM);

    const overlay = mountOverlay(AppId.OVERLAY, actions.toggleOverlay);
    const loadingSpinner = mountLoadingSpinner(AppId.LOADING);
    const footnoteAccordion = mountAccordion(AppId.FF_ACCORDION);
    const imageHeader = mountImageHeader(AppId.IMAGE_HEADER);

    mountCarousel(AppId.TARIFF_CARD);
    mountCarousel(AppId.TARIFF_CARD_FF);
    mountAccordion(AppId.ACCORDION);
    mountRelatedLinks(AppId.RELATED_LINKS);
    mountIconTextBanner(AppId.ICON_TEXT_BANNER);

    mountButtonLink(AddressFormId.LINKS_BUTTON, showLinksView);
    mountButtonLink(AddressFormId.FORM_BUTTON, showFormView);

    actions.initApp(overlay);

    return {
        getDerivedStateFromProps(newState: State, oldState: State) {
            const update = getUpdateFlags(newState, oldState);
            const { isFriendsAndFamily, overlayOpen, loading, activeView, primaryCard } = newState;

            update.leadManagement && leadManagementContainer();
            update.overlay && updateOverlay(overlay, overlayOpen);
            update.loading && updateLoadingSpinner(loadingSpinner, loading);
            update.view && updateActiveView(activeView);
            update.imageHeader && updateImageHeader(imageHeader, isFriendsAndFamily, primaryCard?.type);

            if (update.friendsAndFamily) {
                toggleElementVisibilityById(AppId.TARIFF_CARD_FF, isFriendsAndFamily);
                toggleElementVisibilityById(AppId.TARIFF_CARD, !isFriendsAndFamily);
                toggleElementVisibilityById(AppId.FF_ACCORDION_WRAPPER, isFriendsAndFamily);
                initFootnotes(footnoteAccordion);
            }
        },
    };
}

export default connect(mapStateToProps, actionMap)(appContainer);
